<ng-container *ngIf="resource">
  <a [href]="resource.value" class="resource-tile d-flex flex-column flex-grow-1" target="_blank">
    <dcp-product-tile-content [resource]="resource"></dcp-product-tile-content>
  </a>
</ng-container>
